const tabToken = {
	block: "tab",
	getAttrs: (tok) => tok.attrs,
};

export default tabToken;
